import type { ScheduledChangeDetail } from '@/common/api/models';

type BannerKeyPair = { headline: string; sentence: string };

/**
 * Resolves i18n keys for working-mode campaign detail banners.
 */
export function workingModeBannerKeys(change: ScheduledChangeDetail): BannerKeyPair {
  const publishAs = change.workingMode?.publishAs ?? 'offer_upgrade';
  const reason = change.workingMode?.reason;

  if (change.state === 'scheduled') {
    if (publishAs === 'new_version') {
      return {
        headline: 'lecturer.scheduledChanges.workingMode.banner.scheduledNewVersion.headline',
        sentence: 'lecturer.scheduledChanges.workingMode.banner.scheduledNewVersion.sentence',
      };
    }
    return {
      headline: 'lecturer.scheduledChanges.workingMode.banner.scheduledOfferUpgrade.headline',
      sentence: 'lecturer.scheduledChanges.workingMode.banner.scheduledOfferUpgrade.sentence',
    };
  }
  if (change.state === 'draft_ready') {
    return {
      headline: 'lecturer.scheduledChanges.workingMode.banner.draftReady.headline',
      sentence: 'lecturer.scheduledChanges.workingMode.banner.draftReady.sentence',
    };
  }
  if (change.state === 'live') {
    if (publishAs === 'new_version') {
      return {
        headline: 'lecturer.scheduledChanges.workingMode.banner.liveNewVersion.headline',
        sentence: 'lecturer.scheduledChanges.workingMode.banner.liveNewVersion.sentence',
      };
    }
    return {
      headline: 'lecturer.scheduledChanges.workingMode.banner.liveOfferUpgrade.headline',
      sentence: 'lecturer.scheduledChanges.workingMode.banner.liveOfferUpgrade.sentence',
    };
  }
  if (change.state === 'superseded') {
    if (reason === 'author_took_over') {
      return {
        headline: 'lecturer.scheduledChanges.workingMode.banner.supersededAuthor.headline',
        sentence: 'lecturer.scheduledChanges.workingMode.banner.supersededAuthor.sentence',
      };
    }
    if (reason === 'draft_removed') {
      return {
        headline: 'lecturer.scheduledChanges.workingMode.banner.supersededRemoved.headline',
        sentence: 'lecturer.scheduledChanges.workingMode.banner.supersededRemoved.sentence',
      };
    }
  }
  return {
    headline: `lecturer.scheduledChanges.banner.${change.state}.headline`,
    sentence: `lecturer.scheduledChanges.banner.${change.state}.sentence`,
  };
}

export function workingModeBannerParams(change: ScheduledChangeDetail, extras: {
  date: string;
  time: string;
  zone: string;
}) {
  const applied = change.appliedVersion ?? change.version;
  return {
    date: extras.date,
    version: change.version,
    appliedVersion: applied,
    time: extras.time,
    zone: extras.zone,
    draftVersion: change.workingMode?.draftVersion ?? '',
  };
}
